import type { IconData } from '@stacksjs/iconify-core'

export const comment: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 22H3a1 1 0 0 1-.707-1.707l1.964-1.964A10 10 0 1 1 12 22\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default comment
